import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Title from "../Title";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { asyncGet, asyncPost } from "../../common/utils";
import { URI_PREFIX, URI } from "../../constants/index";
import {
  PRESCRIPTION,
  OPCONSULTATION_REPORT,
  DISCHARGE_SUMMARY,
  DIAGNOSTIC_REPORT,
  PDF_CONTENT,
  DISCHARGE_SUMMARY1,
} from "../../constants/dataconstants";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import "../../assets/styles/App.css";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import parse from "html-react-parser";
import CircularProgress from "@material-ui/core/CircularProgress";
import { FhirResource, fhirVersions } from "fhir-react";
import "fhir-react/build/style.css";
import "fhir-react/build/bootstrap-reboot.min.css";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: 12,
    overflow: "scroll",
  },
  paper: {
    backgroundColor: "#f2efda", // theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    minWidth: 170,
  },
});

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const generateElement = (key, value) => {
  debugger;
  return (
    <React.Fragment>
      {value == "heading" ? (
        <TableRow>
          <TableCell style={{ backgroundColor: "#d3d6d6" }}>
            <strong>{key.toUpperCase()}</strong>
          </TableCell>
          <TableCell style={{ backgroundColor: "#d3d6d6" }}></TableCell>
        </TableRow>
      ) : (
        <TableRow>
          <TableCell>
            <strong>
              {capitalizeFirstLetter(key.toUpperCase() == "DIV" ? "" : key)}
            </strong>
          </TableCell>
          <TableCell>
            {value == null || value == "null" ? "N/A" : parse(urlify(value))}
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
};

const urlify = (text) => {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="_blank">' + url + "</a>";
  });
};

const defaultState = {
  reportType: null,
  report: [],
  excludeResources: ["Practitioner", "Composition"],
  showPdf: false,
  pageNumber: 1,
  pdfContent: "",
  currReportIndex: 0,
  reportName: "",
  imageData: null,
  tabValue: "composition",
};

class TabViewer extends Component {
  constructor(props) {
    super(props);
    this.state = JSON.parse(JSON.stringify(defaultState));
  }
  showImage = (value) => {
    //debugger;
    this.setState({ imageData: value, isModalOpen: true });
  };

  onShowPdf = (value) => {
    //debugger;

    var windo = window.open("", "");
    var objbuilder = "";
    objbuilder +=
      "<embed width='100%' height='100%'  src=\"data:application/pdf;base64,";
    objbuilder += value;
    objbuilder += '" type="application/pdf" />';
    windo.document.write(objbuilder);
  };

  populateReportHeader = (data, repoIndex) => {    
    if (data && data.length > 0) {
      if (repoIndex >= data.length) {
        return <div>No more record found</div>;
      }
      try {
      let arr = data[repoIndex].entry;
      let patientName, bundleTitle, reportName1;
      arr.map((item) => {
        if (
          item.resource &&
          item.resource.resourceType &&
          item.resource.resourceType == "Patient"
        ) {
          // patientName = (item.resource && item.resource.name && item.resource.name[0].text ? item.resource.name[0].text : "N/A");
          patientName = item.resource.name[0].text
        }
        if (
          item.resource &&
          item.resource.resourceType &&
          item.resource.resourceType == "Composition"
        ) {
          bundleTitle = item.resource.title;
        }
      });
      reportName1 = bundleTitle + " of " + patientName;
      return reportName1;
      } catch(error) {
        console.error("Error generating report header:", error.message);
        return "Health Record of Patient";
      }
    }
  };

  populateReport = (data, repoIndex) => {
    let arr = [];
    let identificationNo = "";
    let totalEntries = data.length;
    if (repoIndex >= data.length) {
      return <div>No more record found</div>;
    }
    if (data && data.length > 0) {
      // arr = data[0].entry ? data[0].entry : data[0].entries[repoIndex].data.entry;
      identificationNo = data[repoIndex].id ? data[repoIndex].id : "";
      arr = data[repoIndex].entry;
    }
    let practitionerCount = 0,
      chargeItemCount = 0,
      medicationCount = 0,
      organizationCount = 0;
    let prctnrRsrcCnt = 0,
      chrgItmRsrcCnt = 0,
      mdctnRsrcCnt = 0,
      orgRsrcCnt = 0,
      docRsrcCnt = 0,
      binaryRsrcCnt = 0;
    return (
      <div>
        <Box sx={{ width: "85%", bgcolor: "background.paper" }}>
          <TabContext value={this.state.tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={(event, newValue) => {
                  this.setState({ tabValue: newValue });
                }}
                aria-label="Patient's Health Records"
                textColor="secondary"
                indicatorColor="secondary"
                variant="scrollable"
                scrollButtons="auto"
              >
                {arr.map((item) => {
                  console.log("item : " + JSON.stringify(item));
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "Composition"
                  ) {
                    return <Tab label="Composition" value="composition" />;
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "Patient"
                  ) {
                    return <Tab label="Patient" value="patient" />;
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "Organization"
                  ) {
                    return <Tab label="Organization" value="organization" />;
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "Practitioner"
                  ) {
                    practitionerCount++;
                    if (practitionerCount == 1) {
                      return <Tab label="Practitioner" value="practitioner" />;
                    }
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "Invoice"
                  ) {
                    return <Tab label="Invoice" value="invoice" />;
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "ChargeItem"
                  ) {
                    debugger;
                    chargeItemCount++;
                    if (chargeItemCount == 1) {
                      return <Tab label="ChargeItem" value="chargeItem" />;
                    }
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "Medication"
                  ) {
                    medicationCount++;
                    if (medicationCount == 1) {
                      return <Tab label="Medication" value="medication" />;
                    }
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "DocumentReference"
                  ) {
                    return (
                      <Tab
                        label="Document Reference"
                        value="documentReference"
                      />
                    );
                  }
                  if (
                    item.resource &&
                    item.resource.resourceType &&
                    item.resource.resourceType == "Binary"
                  ) {
                    return <Tab label="Binary Document" value="Binary" />;
                  }
                })}
              </TabList>
            </Box>
            {arr.map((item) => {
              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "Composition"
              ) {
                return (
                  <TabPanel value="composition">
                    <Table style={{ paddingTop: "10px" }}>
                      <TableBody>
                        <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                          <TableCell>Type</TableCell>
                          <TableCell>{item.resource.type.text}</TableCell>
                        </TableRow>
                        <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                          <TableCell>Date</TableCell>
                          <TableCell>{item.resource.date}</TableCell>
                        </TableRow>
                        <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                          <TableCell>Title</TableCell>
                          <TableCell>{item.resource.title}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TabPanel>
                );
              }
              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "Patient"
              ) {
                try {
                  return (
                    <TabPanel value="patient">
                      <Table style={{ paddingTop: "10px" }}>
                        <TableBody>
                          <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                            <TableCell>Name</TableCell>
                            <TableCell>
                              {/* {item.resource.name && item.resource.name.length > 0 ? item.resource.name[0].text : "N/A"} */
                                item.resource.name[0].text
                              }
                            </TableCell>
                          </TableRow>
                          <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                            <TableCell>Gender</TableCell>
                            <TableCell>{item.resource.gender}</TableCell>
                          </TableRow>
                          <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                            <TableCell>ABHA Number</TableCell>
                            <TableCell>
                              {item.resource.identifier &&
                              item.resource.identifier.length > 0
                                ? item.resource.identifier[0].value
                                : ""}
                            </TableCell>
                          </TableRow>
                          <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                            <TableCell>Birth Date/Year</TableCell>
                            <TableCell>
                              {item.resource.birthDate
                                ? item.resource.birthDate
                                : ""}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TabPanel>
                  )
                } catch(error) {
                  return(
                    <TabPanel value="patient">
                      <Table style={{ paddingTop: "10px" }}>
                        <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                        <TableCell>Unable to parse <b>Patient</b> resource !!
                        </TableCell>
                        </TableRow>
                      </Table>
                    </TabPanel>
                    )
                  
                }                
              }

              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "Organization" &&
                orgRsrcCnt++ == 0
              ) {  
                try {
                  return (
                    <TabPanel value="organization">
                      <Table style={{ paddingTop: "10px" }}>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={{ borderBottom: "1px solid #cdcab2" }}
                            >
                              <strong>ID</strong>
                            </TableCell>
                            <TableCell
                              style={{ borderBottom: "1px solid #cdcab2" }}
                            >
                              <strong>Name</strong>
                            </TableCell>
                            <TableCell
                              style={{ borderBottom: "1px solid #cdcab2" }}
                            >
                              <strong>Contact No</strong>
                            </TableCell>
                            <TableCell
                              style={{ borderBottom: "1px solid #cdcab2" }}
                            >
                              <strong>Email</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {arr.map((orgItm) => {
                            if (
                              orgItm.resource &&
                              orgItm.resource.resourceType &&
                              orgItm.resource.resourceType == "Organization"
                            ) {
                              return (
                                <TableRow
                                  style={{ borderBottom: "1px solid #cdcab2" }}
                                >
                                  <TableCell>{orgItm.resource.id}</TableCell>
                                  <TableCell>{orgItm.resource.name}</TableCell>
                                  <TableCell>
                                    {orgItm.resource.telecom.map((tel) => {
                                      if (tel.system == "phone") {
                                        return tel.value;
                                      }
                                    })}
                                  </TableCell>
                                  <TableCell>
                                    {orgItm.resource.telecom.map((tel) => {
                                      if (tel.system == "email") {
                                        return tel.value;
                                      }
                                    })}
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          })}
                        </TableBody>
                      </Table>
                    </TabPanel>
                  )
                } catch (error) {
                  return(
                    <TabPanel value="organization">
                      <Table style={{ paddingTop: "10px" }}>
                        <TableRow style={{ borderBottom: "1px solid #cdcab2" }}>
                        <TableCell>Unable to parse <b>Organization</b> resource !!
                        </TableCell>
                        </TableRow>
                      </Table>
                    </TabPanel>
                    )
                }             
                
              }

              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "Invoice"
              ) {
                return (
                  <TabPanel value="invoice">
                    <div>
                      <label>
                        Invoice No:{" "}
                        {item.resource.identifier &&
                        item.resource.identifier.length > 0
                          ? item.resource.identifier[0].value
                          : ""}
                      </label>
                      &nbsp; &nbsp; &nbsp; &nbsp;
                      <label>
                        Net Amount:{" "}
                        {item.resource.totalNet
                          ? item.resource.totalNet.value
                          : ""}
                      </label>
                      &nbsp; &nbsp; &nbsp; &nbsp;
                      <label>
                        Gross Amount:{" "}
                        {item.resource.totalGross
                          ? item.resource.totalGross.value
                          : ""}
                      </label>
                      &nbsp; &nbsp; &nbsp; &nbsp;
                      <label>
                        Date: {item.resource.date ? item.resource.date : ""}
                      </label>
                    </div>
                    <Table style={{ paddingTop: "10px" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Charge Item</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>MRP</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Base</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>CGST</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>SGST</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {item.resource.lineItem.map((lnItm) => {
                          return (
                            <TableRow
                              style={{ borderBottom: "1px solid #cdcab2" }}
                            >
                              <TableCell>
                                <a
                                  onClick={() => {
                                    this.setState({ tabValue: "chargeItem" });
                                  }}
                                >
                                  {lnItm.chargeItemReference.reference}
                                </a>
                              </TableCell>
                              <TableCell>
                                {lnItm.priceComponent.map((pc) => {
                                  if (pc.code.coding[0].display == "MRP") {
                                    return pc.amount.value;
                                  }
                                })}
                              </TableCell>
                              <TableCell>
                                {lnItm.priceComponent.map((pc) => {
                                  if (pc.code.coding[0].display == "Rate") {
                                    return pc.amount.value;
                                  }
                                })}
                              </TableCell>
                              <TableCell>
                                {lnItm.priceComponent.map((pc) => {
                                  if (pc.code.coding[0].display == "CGST") {
                                    return pc.amount.value;
                                  }
                                })}
                              </TableCell>
                              <TableCell>
                                {lnItm.priceComponent.map((pc) => {
                                  if (pc.code.coding[0].display == "SGST") {
                                    return pc.amount.value;
                                  }
                                })}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TabPanel>
                );
              }

              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "ChargeItem" &&
                chrgItmRsrcCnt++ == 0
              ) {
                return (
                  <TabPanel value="chargeItem">
                    <Table style={{ paddingTop: "10px" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Display</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Id</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Product Reference</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Quantity</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Unit</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Status</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {arr.map((chrgItm) => {
                          if (
                            chrgItm.resource &&
                            chrgItm.resource.resourceType &&
                            chrgItm.resource.resourceType == "ChargeItem"
                          ) {
                            return (
                              <TableRow
                                style={{ borderBottom: "1px solid #cdcab2" }}
                              >
                                <TableCell>
                                  {chrgItm.resource.code.coding &&
                                  chrgItm.resource.code.coding.length > 0
                                    ? chrgItm.resource.code.coding[0].display
                                    : ""}
                                </TableCell>
                                <TableCell>{chrgItm.resource.id}</TableCell>
                                <TableCell>
                                  {chrgItm.resource.productReference.reference}
                                </TableCell>
                                <TableCell>
                                  {chrgItm.resource.quantity.value}
                                </TableCell>
                                <TableCell>
                                  {chrgItm.resource.quantity.unit}
                                </TableCell>
                                <TableCell>{chrgItm.resource.status}</TableCell>
                              </TableRow>
                            );
                          }
                        })}
                      </TableBody>
                    </Table>
                  </TabPanel>
                );
              }

              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "Practitioner" &&
                prctnrRsrcCnt++ == 0
              ) {
                return (
                  <TabPanel value="practitioner">
                    <Table style={{ paddingTop: "10px" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Id</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Name</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {arr.map((prcItm) => {
                          if (
                            prcItm.resource &&
                            prcItm.resource.resourceType &&
                            prcItm.resource.resourceType == "Practitioner"
                          ) {
                            return (
                              <TableRow
                                style={{ borderBottom: "1px solid #cdcab2" }}
                              >
                                <TableCell>{prcItm.resource.id}</TableCell>
                                <TableCell>
                                  {prcItm.resource.name &&
                                  prcItm.resource.name.length > 0
                                    ? prcItm.resource.name[0].text
                                    : ""}
                                </TableCell>
                              </TableRow>
                            );
                          }
                        })}
                      </TableBody>
                    </Table>
                  </TabPanel>
                );
              }

              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "Medication" &&
                mdctnRsrcCnt++ == 0
              ) {
                return (
                  <TabPanel value="medication">
                    <Table style={{ paddingTop: "10px" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Id</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Form</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>LOT Number</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Expiry Date</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {arr.map((mdcItm) => {
                          if (
                            mdcItm.resource &&
                            mdcItm.resource.resourceType &&
                            mdcItm.resource.resourceType == "Medication"
                          ) {
                            return (
                              <TableRow
                                style={{ borderBottom: "1px solid #cdcab2" }}
                              >
                                <TableCell>{mdcItm.resource.id}</TableCell>
                                <TableCell>
                                  {mdcItm.resource.code.coding &&
                                  mdcItm.resource.code.coding.length > 0
                                    ? mdcItm.resource.code.coding[0].display
                                    : ""}
                                </TableCell>
                                <TableCell>
                                  {mdcItm.resource.form && mdcItm.resource.form.coding &&
                                  mdcItm.resource.form.coding.length > 0
                                    ? mdcItm.resource.form.coding[0].display
                                    : ""}
                                </TableCell>
                                <TableCell>
                                  {mdcItm.resource.batch && mdcItm.resource.batch.lotNumber ? mdcItm.resource.batch.lotNumber : ""}
                                </TableCell>
                                <TableCell>
                                  {mdcItm.resource.batch && mdcItm.resource.batch.expirationDate ? mdcItm.resource.batch.expirationDate : "" }
                                </TableCell>
                              </TableRow>
                            );
                          }
                        })}
                      </TableBody>
                    </Table>
                  </TabPanel>
                );
              }

              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "DocumentReference" &&
                docRsrcCnt++ == 0
              ) {
                return (
                  <TabPanel value="documentReference">
                    <Table style={{ paddingTop: "10px" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Id</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Subject</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Title</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Action</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {arr.map((docItm) => {
                          if (
                            docItm.resource &&
                            docItm.resource.resourceType &&
                            docItm.resource.resourceType == "DocumentReference"
                          ) {
                            return (
                              <TableRow
                                style={{ borderBottom: "1px solid #cdcab2" }}
                              >
                                <TableCell>{docItm.resource.id}</TableCell>
                                <TableCell>
                                  {(docItm.resource &&  docItm.resource.subject && docItm.resource.subject.reference ? docItm.resource.subject.reference : "")}
                                </TableCell>
                                <TableCell>
                                  {(docItm.resource &&  docItm.resource.type && docItm.resource.type.text ? docItm.resource.type.text : "")}
                                </TableCell>
                                <TableCell>
                                  {item.resource.content &&
                                    item.resource.content.length > 0 &&
                                    item.resource.content.map((item) => {
                                      if (item.attachment) {
                                        if (
                                          item.attachment.contentType ==
                                          "application/pdf"
                                        ) {
                                          return (
                                            <div style={{ float: "left" }}>
                                              <a
                                                href="javascript:void(0)"
                                                onClick={() =>
                                                  this.onShowPdf(
                                                    item.attachment.data
                                                  )
                                                }
                                              >
                                                {item.attachment.title}
                                              </a>
                                            </div>
                                          );
                                        } else {
                                          return (
                                            <a
                                              href="javascript:void(0);"
                                              onClick={() =>
                                                this.showImage(
                                                  "data:image/png;base64," +
                                                    item.attachment.data
                                                )
                                              }
                                            >
                                              View {item.attachment.title}
                                            </a>
                                          );
                                        }
                                      } else {
                                        if (
                                          item.contentType == "application/pdf"
                                        ) {
                                          return (
                                            <div style={{ float: "left" }}>
                                              <a
                                                href="javascript:void(0)"
                                                onClick={() =>
                                                  this.onShowPdf(item.data)
                                                }
                                              >
                                                {item.title}
                                              </a>
                                            </div>
                                          );
                                        } else {
                                          return (
                                            <a
                                              href="javascript:void(0);"
                                              onClick={() =>
                                                this.showImage(
                                                  "data:image/png;base64," +
                                                    item.data
                                                )
                                              }
                                            >
                                              View {item.title}
                                            </a>
                                          );
                                        }
                                      }
                                    })}
                                </TableCell>
                              </TableRow>
                            );
                          }
                        })}
                      </TableBody>
                    </Table>
                  </TabPanel>
                );
              }

              if (
                item.resource &&
                item.resource.resourceType &&
                item.resource.resourceType == "Binary" &&
                binaryRsrcCnt++ == 0
              ) {
                return (
                  <TabPanel value="Binary">
                    <Table style={{ paddingTop: "10px" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Id</strong>
                          </TableCell>
                          {/* <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Subject</strong>
                          </TableCell>
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Title</strong>
                          </TableCell> */}
                          <TableCell
                            style={{ borderBottom: "1px solid #cdcab2" }}
                          >
                            <strong>Action</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {arr.map((docItm) => {
                          if (
                            docItm.resource &&
                            docItm.resource.resourceType &&
                            docItm.resource.resourceType == "Binary"
                          ) {
                            return (
                              <TableRow
                                style={{ borderBottom: "1px solid #cdcab2" }}
                              >
                                <TableCell>{docItm.resource.id}</TableCell>
                                <TableCell>
                                  {docItm.resource.data &&
                                    (docItm.resource.contentType ==
                                    "application/pdf" ? (
                                      <div style={{ float: "left" }}>
                                        <a
                                          href="javascript:void(0)"
                                          onClick={() =>
                                            this.onShowPdf(docItm.resource.data)
                                          }
                                        >
                                          View
                                        </a>
                                      </div>
                                    ) : (
                                      <a
                                        href="javascript:void(0);"
                                        onClick={() =>
                                          this.showImage(
                                            "data:image/png;base64," +
                                              item.attachment.data
                                          )
                                        }
                                      >
                                        View
                                      </a>
                                    ))}
                                </TableCell>
                              </TableRow>
                            );
                          }
                        })}
                      </TableBody>
                    </Table>
                  </TabPanel>
                );
              }
            })}
          </TabContext>
        </Box>
        <br />
        <div>
          {" "}
          Showing {repoIndex + 1} of {totalEntries} records
        </div>
      </div>
    );
  };

  componentDidMount() {
    this.setState({ showLoader: true });
    // setTimeout(() => {
    //     this.fetchConsentArtefacts();
    // }, 6000);
    this.fetchConsentArtefacts();
  }

  //To get the Consent Artefact of the Respective User
  fetchConsentArtefacts = async () => {
    // debugger;
    const url =
      URI.getConsentArtefacts + "?consentReqId=" + global.consentReqId;
    const res = await asyncGet(url, true, global.token, true, false);
    if (res && res.status == 2000) {
      // debugger
      let arr = [];
      if (res.data && res.data.length > 0) {
        // debugger;
        res.data.map((item) => {
          let arrDecoded = JSON.parse(item.decodedValue);
          if (arrDecoded) {
            console.log("json : " + item.decodedValue);
            arr.push(JSON.parse(item.decodedValue));
          }
        });
      }
      console.log("size of arr :" + arr.length);
      // debugger
      this.setState({ showLoader: false, report: arr });
    } else {
      this.setState({ showLoader: false });
      alert("Unable to find record.");
    }
  };

  handleModalClose = () => {
    this.setState({ showPdf: false });
  };

  handlePrevious = () => {
    let currIndex = this.state.currReportIndex;
    if (currIndex > 0) {
      currIndex = currIndex - 1;
      this.setState({ currReportIndex: currIndex });
    }
  };

  handleNext = () => {
    let currIndex = this.state.currReportIndex;
    if (currIndex < this.state.report.length) {
      currIndex = currIndex + 1;
      this.setState({ currReportIndex: currIndex });
    }
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false, modalFor: "", imageData: null });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Paper className={classes.paper} style={{ padding: "10px" }}>
          <div style={{ float: "right" }}>
            <a
              href="javascript:history.go(-1)"
              style={{ textDecoration: "none" }}
            >
              Back
            </a>
          </div>
          {!this.state.showLoader ? (
            <Grid container direction={"row"} spacing={5}>
              <Table size="small" style={{ margin: "30px" }}>
                <TableBody style={{ textAlign: "left" }}>
                  <Box justifyContent="center" display="flex">
                    <Button type="button" onClick={() => this.handlePrevious()}>
                      <KeyboardArrowLeftIcon />
                    </Button>
                    <div style={{ marginTop: 8 }}>
                      {this.state.report && this.state.report.length > 0
                        ? this.populateReportHeader(
                            this.state.report,
                            this.state.currReportIndex
                          )
                        : "No data found."}
                    </div>
                    <Button type="button" onClick={() => this.handleNext()}>
                      <KeyboardArrowRightIcon />
                    </Button>
                  </Box>
                  {this.state.report && this.state.report.length > 0
                    ? this.populateReport(
                        this.state.report,
                        this.state.currReportIndex
                      )
                    : "No data found."}
                </TableBody>
              </Table>
            </Grid>
          ) : (
            <React.Fragment>
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress style={{ color: global.secondaryColour }} />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            </React.Fragment>
          )}
        </Paper>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={this.state.isModalOpen}
          onClose={() => this.handleModalClose()}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.state.isModalOpen}>
            <div style={{ padding: 10, backgroundColor: "#ffffff" }}>
              <div style={{ alignContent: "center" }}>
                <h6>
                  <strong>VIEW REPORT</strong>
                </h6>
              </div>
              <img src={this.state.imageData} />
              <div style={{ alignContent: "center" }}>
                <Button type="button" onClick={() => this.handleModalClose()}>
                  <CloseIcon />
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
      </React.Fragment>
    );
  }
}

TabViewer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TabViewer);
